"use client";

import { useEffect } from "react";

import { logErrorToCloudWatch } from "@/shared/lib/aws/cloudwatch";

import { Layout } from "./ui/Layout/Layout";

export default function GlobalError({ error, reset }: { error: { digest?: string } & Error; reset: () => void }) {
    useEffect(() => {
        // Log the error to CloudWatch
        logErrorToCloudWatch(error, undefined, {
            digest: error.digest,
            type: "global_error_boundary",
        });
    }, [error]);

    return (
        <html lang="en">
            <body>
                <div className="flex flex-col items-center justify-center min-h-screen p-4">
                    <h2 className="text-xl font-bold mb-2">Something went wrong</h2>
                    <p className="text-gray-600 mb-4">We&apos;ve been notified and are working to fix the issue.</p>
                    <button className="px-4 py-2 bg-primary text-white rounded" onClick={() => reset()}>
                        Try again
                    </button>
                </div>
            </body>
        </html>
    );
}
